'use strict'
// Template version: 1.2.3
// see http://vuejs-templates.github.io/webpack for documentation.

const serverUrl = '/apply/';
const designerUrl = "/apply/";



// const serverUrl = '/api/';
// const designerUrl = "http://192.168.10.109/";

const homePage='/home/center'


module.exports = {
    serverUrl: serverUrl,
    designerUrl: designerUrl,
    homePage: homePage,
}
